import React from 'react';
import styles from './theme-preview-example.less';
import i18n from 'i18next';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';

interface IThemePreviewExampleProps {
    themeConfig: IThemeSelectItem,
}

export class ThemePreviewExample extends React.Component<IThemePreviewExampleProps, any> {
    render() {
        const { themeConfig } = this.props;

        return <div className={styles['theme-preview-example-container']}>
            <ThemePreviewImage themeConfig={themeConfig} mode={'white'} />
            <ThemePreviewImage themeConfig={themeConfig} mode={'dark'} />
        </div>;
    }
}

interface IThemePreviewImageProps {
    mode: 'dark' | 'white';
    themeConfig: IThemeSelectItem;
}

class ThemePreviewImage extends React.Component<IThemePreviewImageProps, any> {
    render() {
        const { themeConfig, mode } = this.props;
        const { colorSchema } = themeConfig;
        const isDark = mode === 'dark';
        const {
            dk1,
            dk2,
            lt1,
            lt2,
            accent1,
            accent2,
            accent3,
            accent4,
            accent5,
            accent6,
        } = colorSchema;

        const bg1 = isDark ? dk1 : lt1;
        const bg2 = isDark ? dk2 : lt2;
        const tx1 = isDark ? lt1 : dk1;
        const tx2 = isDark ? lt2 : dk2;
        const border = `1px solid #${tx1.color}`;

        return colorSchema ? <div
            className={styles['theme-preview-example-image-wrapper']}
            style={{
                background: `#${bg2.color}`,
            }}
        >
            <div
                className={styles['theme-preview-example-text']}
                style={{
                    color: `#${tx1.color}`,
                }}
            >
                { i18n.t('文字') }
            </div>
            <div className={styles['theme-preview-example-shape']}>
                <div
                    className={styles['theme-preview-example-shape-circle']}
                    style={{
                        border,
                        background: `#${lt1.color}`,
                    }}
                >
                    <svg
                        style={{
                            position: 'relative',
                            right: 1,
                        }}
                        xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <path d="M35.2499 23.1097L33.9177 21.4443L32.5855 23.1097L31.2532 21.4443L29.921 23.1097L28.5888 21.4443L27.2566 23.1097L25.9244 21.4443L24.5922 23.1097L23.26 21.4443L21.9278 23.1097L20.5955 21.4443L19.2633 23.1097L17.9311 21.4443L16.5989 23.1097L15.2667 21.4443L13.9345 23.1097L12.6023 21.4443L11.2701 23.1097L9.93785 21.4443L8.60564 23.1097" stroke={`#${accent1.color}`}/>
                    </svg>
                </div>
                <div
                    className={styles['theme-preview-example-shape-rect']}
                    style={{
                        border,
                        background: `linear-gradient(90deg, white, #${accent1.color})`,
                    }}
                ></div>
            </div>
            <div
                className={styles['theme-preview-example-accent-wrapper']}
            >
                <div
                    className={styles['theme-preview-example-accent']}
                    style={{
                        height: 16,
                        background: `#${accent1.color}`,
                        border,
                        borderRight: 'none',
                    }} />
                <div
                    className={styles['theme-preview-example-accent']}
                    style={{
                        height: 36,
                        background: `#${accent2.color}`,
                        border,
                        borderRight: 'none',
                    }} />
                <div
                    className={styles['theme-preview-example-accent']}
                    style={{
                        height: 60,
                        background: `#${accent3.color}`,
                        border,
                    }} />
                <div
                    className={styles['theme-preview-example-accent']}
                    style={{
                        height: 48,
                        background: `#${accent4.color}`,
                        border,
                        borderLeft: 'none',
                    }} />
                <div
                    className={styles['theme-preview-example-accent']}
                    style={{
                        height: 16,
                        background: `#${accent5.color}`,
                        border,
                        borderLeft: 'none',
                        borderRight: 'none',
                    }} />
                <div
                    className={styles['theme-preview-example-accent']}
                    style={{
                        height: 24,
                        background: `#${accent6.color}`,
                        border,
                    }} />
            </div>
        </div> : null;
    }
}
